import type { ReactNode } from "react"

import { RequiresLargerScreen } from "@/components/kit/RequiresLargerScreen"
import { useIsMobile } from "@/hooks/use-mobile"

/** A route not declared `phoneSafe` renders the "best on a larger screen"
 *  state on a phone-width viewport, INSTEAD of its own element -- one
 *  mechanism here rather than a `useIsMobile()` check scattered across every
 *  screen (LLD §7.4). */
export function PhoneScreenGuard({ phoneSafe, children }: { phoneSafe: boolean; children: ReactNode }) {
  const isMobile = useIsMobile()
  if (isMobile && !phoneSafe) return <RequiresLargerScreen />
  return <>{children}</>
}
